module.exports = __webpack_public_path__ + "static/media/113.3c4c4ccb.svg";